module.exports = __webpack_public_path__ + "static/media/add-column.2f1463bf.svg";